import {
  ComplianceDocumentType_Read,
  ComplianceDocumentType_Read_Nested,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export type FieldType = 'none' | 'string' | 'number' | 'date' | 'boolean';

export class ComplianceDocumentTypeBasic {
  constructor(
    private _id: string,
    private _name: string,
    private _external_id: string,
    private _field_type: FieldType,
    private _has_expiration: boolean,
    private _dispatch_gating: boolean,
    private _required_vendors: boolean,
    private _required_internal_drivers: boolean,
    private _required_shared_drivers: boolean,
    private _required_equipment: boolean,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public static parse(proto: ComplianceDocumentType_Read_Nested) {
    return new ComplianceDocumentTypeBasic(
      proto.id ?? '',
      proto.name ?? '',
      proto.external_id ?? '',
      (proto.field_type ?? 'none') as FieldType,
      proto.has_expiration ?? false,
      proto.dispatch_gating ?? false,
      proto.required_vendors ?? false,
      proto.required_internal_drivers ?? false,
      proto.required_shared_drivers ?? false,
      proto.required_equipment ?? false,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }
  public get name() {
    return this._name;
  }
  public get externalId() {
    return this._external_id;
  }
  public get fieldType() {
    return this._field_type;
  }
  public get hasExpiration() {
    return this._has_expiration;
  }
  public get dispatchGating() {
    return this._dispatch_gating;
  }
  public get requiredVendors() {
    return this._required_vendors;
  }
  public get requiredInternalDrivers() {
    return this._required_internal_drivers;
  }
  public get requiredSharedDrivers() {
    return this._required_shared_drivers;
  }
  public get requiredEquipment() {
    return this._required_equipment;
  }
  public get discardedAt() {
    return this._discarded_at;
  }
}

export class ComplianceDocumentType {
  constructor(
    private _id: string,
    private _name: string,
    private _external_id: string,
    private _description: string,
    private _field_type: FieldType,
    private _has_expiration: boolean,
    private _dispatch_gating: boolean,
    private _required_vendors: boolean,
    private _required_internal_drivers: boolean,
    private _required_shared_drivers: boolean,
    private _required_equipment: boolean,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public static parse(proto: ComplianceDocumentType_Read) {
    return new ComplianceDocumentType(
      proto.id ?? '',
      proto.name ?? '',
      proto.external_id ?? '',
      proto.description ?? '',
      (proto.field_type ?? 'none') as FieldType,
      proto.has_expiration ?? false,
      proto.dispatch_gating ?? false,
      proto.required_vendors ?? false,
      proto.required_internal_drivers ?? false,
      proto.required_shared_drivers ?? false,
      proto.required_equipment ?? false,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }
  public get name() {
    return this._name;
  }
  public get externalId() {
    return this._external_id;
  }
  public get description() {
    return this._description;
  }
  public get fieldType() {
    return this._field_type;
  }
  public get hasExpiration() {
    return this._has_expiration;
  }
  public get dispatchGating() {
    return this._dispatch_gating;
  }
  public get requiredVendors() {
    return this._required_vendors;
  }
  public get requiredInternalDrivers() {
    return this._required_internal_drivers;
  }
  public get requiredSharedDrivers() {
    return this._required_shared_drivers;
  }
  public get requiredEquipment() {
    return this._required_equipment;
  }
  public get createdAt() {
    return dayjs.tz(this._created_at);
  }
  public get updatedAt() {
    return dayjs.tz(this._updated_at);
  }
  public get discardedAt() {
    return this._discarded_at;
  }
}
